import React from 'react';
import { Link as RouterLink } from 'next/link';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from 'react-apollo';
import { useSnackbar } from 'notistack';
import { Grid, Typography, Box, Link, TextField } from '@material-ui/core';

import { Button, colors } from '@eureca/eureca-ui';

import { SUPPORT_REQUEST } from '@/api/mutation/consultant/index';

import { yupValidators } from '@/helpers/validations';

const phoneRegExp =
  /^1\d\d(\d\d)?$|^0800 ?\d{3} ?\d{4}$|^(\(0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d\) ?|0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d[ .-]?)?(9|9[ .-])?[2-9]\d{3}[ .-]?\d{4}$/gm;

const validationSchema = Yup.object().shape({
  name: yupValidators.name,
  email: yupValidators.email,
  phone: Yup.string().matches(
    phoneRegExp,
    'O número de telefone não é válido.',
  ),
  messageSupport: Yup.string().required('Favor descrever sua necessidade.'),
});

const initialValues = {
  name: '',
  email: '',
  phone: '',
  messageSupport: '',
};

function Help() {
  const { enqueueSnackbar } = useSnackbar();
  const [helpMutation] = useMutation(SUPPORT_REQUEST, {
    onCompleted() {
      enqueueSnackbar('Solicitação enviada com sucesso!', {
        variant: 'success',
      });
      enqueueSnackbar(
        'Retornaremos seu contato por e-mail em até 2 dias úteis.',
        { variant: 'default' },
      );
      // eslint-disable-next-line no-use-before-define
      helpFormik.resetForm();
    },
    onError() {
      enqueueSnackbar('Algo deu errado.', { variant: 'error' });
    },
  });
  function handleSubmit(variables) {
    helpMutation({ variables });
  }
  const helpFormik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Grid item container xs={12} sm={5} md={6} spacing={0}>
      <form onSubmit={helpFormik.handleSubmit}>
        <Grid item xs={12}>
          <Box mb={3} textAlign={{ xs: 'center', md: 'left' }}>
            <Typography variant="h3">Como podemos te servir?</Typography>
            <Typography style={{ color: colors.gray3 }}>
              Preencha os campos abaixo e em breve receba as instruções para
              navegação.
            </Typography>
          </Box>
          <Box mb={4}>
            <TextField
              variant="outlined"
              label="Nome"
              margin="normal"
              fullWidth
              name="name"
              onChange={helpFormik.handleChange}
              onBlur={helpFormik.handleBlur}
              value={helpFormik.values.name}
              error={helpFormik.errors.name && helpFormik.touched.name}
              helperText={
                helpFormik.touched.name && helpFormik.errors.name
                  ? helpFormik.errors.name
                  : ''
              }
            />
            <TextField
              variant="outlined"
              label="E-mail"
              margin="normal"
              fullWidth
              name="email"
              onChange={helpFormik.handleChange}
              onBlur={helpFormik.handleBlur}
              value={helpFormik.values.email}
              error={helpFormik.errors.email && helpFormik.touched.email}
              helperText={
                helpFormik.touched.email && helpFormik.errors.email
                  ? helpFormik.errors.email
                  : ''
              }
            />
            <TextField
              variant="outlined"
              label="Telefone"
              helperText={
                helpFormik.touched.phone && helpFormik.errors.phone
                  ? helpFormik.errors.phone
                  : 'Opcional'
              }
              margin="normal"
              fullWidth
              name="phone"
              inputProps={{ type: 'tel', autoComplete: 'tel' }}
              onChange={helpFormik.handleChange}
              onBlur={helpFormik.handleBlur}
              value={helpFormik.values.phone}
              error={helpFormik.errors.phone && helpFormik.touched.phone}
            />
            <TextField
              variant="outlined"
              label="Descreva sua necessidade"
              multiline
              rows={3}
              fullWidth
              name="messageSupport"
              onChange={helpFormik.handleChange}
              onBlur={helpFormik.handleBlur}
              value={helpFormik.values.messageSupport}
              error={
                helpFormik.errors.messageSupport &&
                helpFormik.touched.messageSupport
              }
              helperText={
                helpFormik.touched.messageSupport &&
                helpFormik.errors.messageSupport
                  ? helpFormik.errors.messageSupport
                  : ''
              }
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Button
              variant="contained"
              disabled={!helpFormik.isValid}
              style={{ paddingRight: 32, paddingLeft: 32 }}
              onClick={helpFormik.handleSubmit}
            >
              Solicitar ajuda
            </Button>
            <Link component={RouterLink} href="/">
              Fazer login
            </Link>
          </Box>
        </Grid>
      </form>
    </Grid>
  );
}

export default Help;
